export const InvoiceRouting = [
  {
    path: "/contract/invoice/list",
    name: "contract-invoice-list",
    meta: { title: "开票申请" },
    component: () =>
      import(/* webpackChunkName: "contract-invoice" */ "@/views/contract/invoice/list/index.vue"),
  },
  {
    hidden: true,
    path: "/contract/invoice/create",
    name: "contract-invoice-create",
    meta: { title: "新增开票申请",comName:"contractInvoiceFormCreate" },
    component: () =>
      import(/* webpackChunkName: "contract-invoice" */ "@/views/contract/invoice/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/contract/invoice/edit/:id",
    name: "contract-invoice-edit",
    meta: { title: "编辑开票申请" ,comName:"contractInvoiceFormCreate"},
    component: () =>
      import(/* webpackChunkName: "contract-invoice" */ "@/views/contract/invoice/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/contract/invoice/detail/:id",
    name: "contract-invoice-detail",
    meta: { title: "开票申请详情" },
    component: () =>
      import(
        /* webpackChunkName: "contract-invoice" */ "@/views/contract/invoice/form-detail/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/contract/invoice/flowPrint/:id",
    name: "contract-invoice-flow-print",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "contract-invoice" */ "@/views/contract/invoice/flow-print/index.vue"
      ),
  }
];
